import React from "react";
import { useQuery } from "@apollo/client";
import PropTypes from "prop-types";
import getIntervention from "../graphql/queries/getBsffInterventionsFromIntervention.graphql";
import LoadingWrapper from "../../common/components/elements/LoadingWrapper";
import BsffList from "./BsffList";

BsffInterventionInformation.propTypes = {
  interventionUuid: PropTypes.string.isRequired,
};

export default function BsffInterventionInformation({ interventionUuid }) {
  const { loading, error, data } = useQuery(getIntervention, {
    variables: {
      interventionUuid,
    },
  });

  return (
    <LoadingWrapper loading={loading} error={Boolean(error)}>
      {() => {
        const bsffIntervention = data.getBsffInterventionFromIntervention;

        return (
          <div className="mt-3">
            <BsffList
              bsffs={bsffIntervention ? bsffIntervention.bsffs : []}
              showTrackdechetsSynced={true}
              trackdechetsSynced={Boolean(bsffIntervention)}
            />
          </div>
        );
      }}
    </LoadingWrapper>
  );
}
